import { StyleSheet } from 'react-native';
import { BLACK, LILAC_400, tokens } from '@airtel/air-design-system';
export var getImmersiveWidgetStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_20 = _tokens$spacing.SPACING_20,
    SPACING_10 = _tokens$spacing.SPACING_10;
  return StyleSheet.create({
    subContainer: {
      padding: SPACING_20
    },
    container: {
      backgroundColor: BLACK
    },
    growthInventoryImage: {
      borderRadius: 0
    },
    keyPair: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    keyPairUnit: {
      maxWidth: '65%'
    },
    button: {
      backgroundColor: LILAC_400
    },
    title: {
      color: BLACK
    },
    engagementRail: {
      paddingHorizontal: SPACING_10
    },
    engagementRailSection: {
      paddingHorizontal: SPACING_20
    },
    engagementRailContainer: {
      marginVertical: SPACING_10
    },
    bottomSectionGrowthInventory: {
      marginVertical: SPACING_10
    },
    growthInventorySection: {
      paddingHorizontal: SPACING_20
    }
  });
};